export const REF_TZ = 'Europe/Amsterdam';

// Minutes that `tz` is ahead of UTC at a given instant.
export function tzOffsetMinutes(date, tz) {
  const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
    .formatToParts(date).reduce((a, p) => ({ ...a, [p.type]: p.value }), {});
  const asUtc = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
  return Math.round((asUtc - date.getTime()) / 60000);
}

// Next instant matching a weekly { day, time:'HH:mm' } slot defined in Europe/Amsterdam.
export function nextOccurrence(slot, now = new Date()) {
  const [hh, mm] = slot.time.split(':').map(Number);
  for (let i = 0; i < 8; i += 1) {
    const probe = new Date(now.getTime() + i * 86400000);
    const p = new Intl.DateTimeFormat('en-US', { timeZone: REF_TZ, year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' })
      .formatToParts(probe).reduce((a, x) => ({ ...a, [x.type]: x.value }), {});
    const wd = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
    if (wd !== slot.day) continue;
    const naive = new Date(Date.UTC(+p.year, +p.month - 1, +p.day, hh, mm));
    const at = new Date(naive.getTime() - tzOffsetMinutes(naive, REF_TZ) * 60000);
    if (at > now) return at;
  }
  return null;
}

export function nextStream(schedule, now = new Date()) {
  return schedule.map((s) => nextOccurrence(s, now)).filter(Boolean).sort((a, b) => a - b)[0] || null;
}

export const fmtLocal = (d, tz) => d.toLocaleString([], { timeZone: tz, weekday: 'short', day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', timeZoneName: 'short' });
